import React from "react";

interface FreeTextProps {
        content: string;
}
const FreeText: React.FC<FreeTextProps> = ({content}) => {
    // eslint-disable-next-line react/no-danger
        return <div dangerouslySetInnerHTML={{ __html: content }} />;
};

export default FreeText;
